const urlParameters = new URLSearchParams(window.location.search);

export const isLingerie =
  urlParameters.get("category") === "lingerie" ||
  urlParameters.get("lingerie") === "true";

export const isFootwear =
  urlParameters.get("category") === "footwear" ||
  urlParameters.get("footwear") === "true";

export const isChildren =
  urlParameters.get("category") === "children" ||
  urlParameters.get("kids") === "true";

export const isSpecificFlow = isFootwear || isChildren || isLingerie;
